<template>
  <section class="consumer-model-section">
    <div class="consumer-model-inner">
      <div class="eyebrow">— {{ $t("home.v2.consumer.eyebrow") }}</div>
      <h2>
        {{ $t("home.v2.consumer.title1") }}
        <span>{{ $t("home.v2.consumer.title2") }}</span>
      </h2>
      <div class="feature-grid">
        <div v-for="item in featureList" :key="item.id" class="feature-row">
          <div class="feature-index">
            <div>{{ item.index }}</div>
            <img :src="item.icon" :alt="item.title" />
          </div>
          <div class="feature-copy">
            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ConsumerModelSection",
  computed: {
    featureList() {
      return [
        {
          id: 1,
          index: "01",
          icon: require("@/assets/img/images/home/mask-group-1.png"),
          title: this.$t("home.v2.consumer.item1.title"),
          desc: this.$t("home.v2.consumer.item1.desc"),
        },
        {
          id: 2,
          index: "02",
          icon: require("@/assets/img/images/home/mask-group-2.png"),
          title: this.$t("home.v2.consumer.item2.title"),
          desc: this.$t("home.v2.consumer.item2.desc"),
        },
        {
          id: 3,
          index: "03",
          icon: require("@/assets/img/images/home/mask-group-3.png"),
          title: this.$t("home.v2.consumer.item3.title"),
          desc: this.$t("home.v2.consumer.item3.desc"),
        },
      ];
    },
  },
};
</script>

<style lang="less" scoped>
.consumer-model-section {
  width: 100%;
  box-sizing: border-box;
  background: #f7f6f4;
  padding: 100px 60px;
}

.consumer-model-inner {
  box-sizing: border-box;
  .eyebrow {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 18px;
    color: #333333;
    text-transform: uppercase;
  }

  h2 {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    // 字号随视口缩放，保证越南语等长文案单行显示不换行
    font-size: clamp(32px, 2.75vw, 60px);
    color: #333333;
    line-height: 1.35;
    white-space: nowrap;
    padding-bottom: 60px;

    span {
      color: #E05807;
    }
  }
}

.feature-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 44px;
  padding-top: 48px;
  border-top: 1px solid rgba(112, 112, 112, 0.2);
}

.feature-row {
  display: flex;
  .feature-index {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 34px;
    color: #E05807;
    margin-right: 24px;
    display: flex;
    align-items: center;
    height: fit-content;
    img {
      width: 46px;
      height: 46px;
      margin-left: 24px;
    }
  }

  h3 {
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 26px;
    color: #333333;
  }

  p {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 22px;
    color: #333333;
    margin-top: 8px;
  }
}
</style>
